import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHome, FiUsers, FiFileText, FiLogOut, FiTrendingUp } = FiIcons;

const Sidebar = ({ currentView, setCurrentView, onLogout, selectedClient }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: FiHome },
    { id: 'clients', label: 'Clients', icon: FiUsers },
    { id: 'reports', label: 'Reports', icon: FiFileText }
  ];

  return (
    <div className="w-64 bg-white border-r border-gray-200 h-screen flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-br from-[#00A859] to-[#002B60] rounded-lg flex items-center justify-center">
            <SafeIcon icon={FiTrendingUp} className="text-white text-lg" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-800">AlbertaRank</h1>
            <p className="text-xs text-gray-500">SEO Dashboard</p>
          </div>
        </div>
      </div>

      {/* Client Info */}
      {selectedClient && (
        <div className="p-4 bg-gray-50 border-b border-gray-200">
          <p className="text-xs text-gray-500 uppercase tracking-wide">Current Client</p>
          <p className="font-medium text-gray-800 truncate">{selectedClient.name}</p>
        </div>
      )}

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.id}>
              <motion.button
                whileHover={{ x: 4 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => setCurrentView(item.id)}
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-all duration-200 ${
                  currentView === item.id
                    ? 'bg-[#00A859] text-white shadow-md'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <SafeIcon icon={item.icon} className="text-lg" />
                <span className="font-medium">{item.label}</span>
              </motion.button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-gray-200">
        <motion.button
          whileHover={{ x: 4 }}
          whileTap={{ scale: 0.98 }}
          onClick={onLogout}
          className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-600 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
        >
          <SafeIcon icon={FiLogOut} className="text-lg" />
          <span className="font-medium">Logout</span>
        </motion.button>
      </div>
    </div>
  );
};

export default Sidebar;